module.exports = __webpack_public_path__ + "images/interior-3d-a78cce60918a13928f5aff3a65a87ebc.svg";